export default [
    {
        path: 'plants',
        name: 'plants',
        component: () => import('./views/PlantsView.vue'),
        meta: { 
            requiresAuth: true,
            title: 'Plantas' 
        },
    },
    {
        path: 'logs-facturacion',
        name: 'logs-facturacion',
        component: () => import('./views/LogsFacturacionView.vue'),
        meta: { 
            requiresAuth: true,
            title: 'Logs Facturación' 
        },
    }
]